import { useCallback } from "react";

const useHandleScroll = (
  hasMore: boolean,
  setPage: (page: number | ((prevPage: number) => number)) => void
) => {
  const handleScroll = useCallback(
    async (event: React.UIEvent) => {
      const container = event.target as HTMLElement;
      if (
        container.scrollHeight - container.scrollTop ===
          container.clientHeight &&
        hasMore
      ) {
        setPage((prevPage: number) => prevPage + 1);
      }
    },
    [hasMore, setPage]
  );

  return { handleScroll };
};

export default useHandleScroll;
